import { render, staticRenderFns } from "./CohortForm.vue?vue&type=template&id=3f36c7be"
import script from "./CohortForm.vue?vue&type=script&lang=js"
export * from "./CohortForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports